import { createSlice } from "@reduxjs/toolkit";
import { EngagementSubmission, FormFieldType } from "./Types";

type initialStateType = {
   formFieldsEngagement: FormFieldType[];
   engagementSubmissions: EngagementSubmission[];
   engagementById: EngagementSubmission | null;
    status: {
        formFieldsEngagementLoading: boolean;
        submitFormEngagementLoading: boolean;
        submitFormEngagementStatus: boolean;
        submitFormEngagementMessage: string;
        engagementSubmissionsLoading: boolean;
        engagementByIdLoading: boolean;
        reviewLoading: Record<string, boolean>;
        deleteLoading: Record<string, boolean>;
    };
}

var initialState: initialStateType = {
    formFieldsEngagement: [],
    engagementSubmissions: [],
    engagementById: null,
    status: {
        formFieldsEngagementLoading: false,
        submitFormEngagementLoading: false,
        submitFormEngagementStatus: false,
        submitFormEngagementMessage: "",
        engagementSubmissionsLoading: false,
        engagementByIdLoading: false,
        reviewLoading: {},
        deleteLoading: {},
    }
};

const engagementFormSlice = createSlice({
    name : "engagement-form",
    initialState : initialState,
    reducers : {
        setFormFieldsEngagement: (state, action) => {
            state.formFieldsEngagement = action.payload; 
        },
        setFormFieldsEngagementLoading : (state, action) => {
            state.status.formFieldsEngagementLoading = action.payload;
        },
        setSubmitFormEngagementLoading : (state, action) => {
            state.status.submitFormEngagementLoading = action.payload;
        },
        setSubmitFormEngagementStatus : (state, action) => {
            state.status.submitFormEngagementStatus = action.payload;
        },
        setSubmitFormEngagementMessage : (state, action) => {
            state.status.submitFormEngagementMessage = action.payload;
        },
        setEngagementSubmissions: (state, action) => {
            state.engagementSubmissions = action.payload; 
        },
        setEngagementSubmissionsLoading: (state, action) => {
            state.status.engagementSubmissionsLoading = action.payload; 
        },
        setEngagementById: (state, action) => {
            state.engagementById = action.payload; 
        },
        setEngagementByIdLoading: (state, action) => {
            state.status.engagementByIdLoading = action.payload; 
        },
        setReviewLoading: (state, action) => {
            const { engagementId, loading } = action.payload;
            state.status.reviewLoading[engagementId] = loading;
        },
        setDeleteLoading: (state, action) => {
            const { engagementId, loading } = action.payload;
            state.status.deleteLoading[engagementId] = loading;
        },
    }
})

export const engagementFormSliceReducer = engagementFormSlice.reducer;
export const engagementFormSliceAction = engagementFormSlice.actions;